module.exports = __webpack_public_path__ + "img/section5_title2.5e9cf8c0.png";